import { toggleSceneObject } from "../../togglers";

export const changeRuchkaSyomnaya = (isChecked) => {
    const tempName = servObj.tempName;

    const width = servObj.tableSize.tableWidth.current;
    const depth = servObj.tableSize.tableDepth.current;

    const name = `ruchka__stol__${tempName}__${width}x${depth}`;

    toggleSceneObject({
        allObjects: servObj.allRuchkaSP,
        activeArray: servObj.activeRuchkaSP,
        name,
        isChecked,
        filterActiveFn: () => {},
        position: {
            y: 10,
        },
        userData: {
            // type: value,
            position: "bottom",
        },
    });
};
